import { useEffect, useRef, useState } from 'react';
import { TextGradient } from '../../components/textGradient/TextGradient'
import styles from './RaitingPage.module.css'
import { Table } from 'antd';
import { ActivityType, getDescriptionActivity, mainData, UserRateDomain } from '../../models/commonModels';
import {columns} from './RaitingTableProps'
import  './fields-view-settings-global-styles.css'
import { getRaitingData } from './RaitngApi';
import { Preloader } from '../../components/preloader/preloader';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { ActivityBar } from '../../components/ActivityBar/ActivityBar';
import { useNavigate } from 'react-router-dom';
import { setProfileId } from '../../store/app-slice/AppSlice';
export const RaitingPage = () =>{
const activity = useAppSelector(state=>state.appStore.activity_type)
const [size,setSize] = useState(0)
const refContainer = useRef<HTMLDivElement>(null)
const [tableData,setTableData] = useState<UserRateDomain[]>([])
const [distance_length, setDistance_length] = useState(0)
const [activity_distance,setActivity_distance]=useState(0)
const [onLoad,setLoad]=useState(false)
const [leastActivity,setLeastActivity]=useState<ActivityType|null>(null)
const navigation = useNavigate();
const dispatch:any = useAppDispatch();

 useEffect(() => {
    if(leastActivity!=activity){
        setLeastActivity(activity)
        fetchData();
        //return;
    }else{
      tableData.length==0&&fetchData();
    }
    
    debugger
    if (!refContainer.current) {
      return;
    }

    const resizeObserver = new ResizeObserver(() => {
      debugger
      if(refContainer?.current?.offsetHeight !== size) { //HERE
        setSize(refContainer?.current?.offsetHeight!=undefined?refContainer?.current?.offsetHeight:0);
      }
    });
    resizeObserver.observe(refContainer.current);

    return function cleanup() {
      resizeObserver.disconnect();
    }
  },
  [refContainer.current,activity])

  async function fetchData() {
    if(activity==null)return
    setLoad(true)
    const tableData:mainData|null = await getRaitingData(activity)
    setLoad(false)
    if(tableData!=null){
          tableData.data!=null&&setTableData(tableData.data)
          setDistance_length(tableData.distance_length)
          setActivity_distance(tableData.activity_distance)
    }
  }
    return (
    <div className={styles.raiting_page_container} ref = {refContainer}>
            <div className={styles.raiting_page_content}>
                <TextGradient
                    colors={["#739E72","#1C6A93","#F65B3E"]}
                    // text={mainData.distance_length.toLocaleString('ru-RU')}
                    text={distance_length.toLocaleString('ru-RU')}
                    fontSize={"36px"}
                    fontWeigth={"700"}/>
                <TextGradient
                    colors={["#739E72","#1C6A93","#F65B3E"]}
                    text={"ОБЩИЙ РЕЗУЛЬТАТ, КМ"}
                    fontSize={"12px"}
                    fontWeigth={"400"}/>
                <ActivityBar/>
                <div className={styles.raiting_page_activity_resilt}>
                    {activity_distance.toLocaleString('ru-RU')}
                </div>
                <div>{getDescriptionActivity(activity,false)}</div>
            </div>
             
            <div style={{marginTop:"10px"}}>
              <Table<UserRateDomain>
                onRow={(record, rowIndex) => {
                return {
                  onClick: event => { 
                    dispatch(setProfileId(record.user_id))
                                    navigation('/profileId')
                  }, // click row
                };
              }}
                columns={columns}
                dataSource={tableData}
                scroll={{ y: size-250}}
                pagination={false}/>
            </div>
            {onLoad&&<Preloader/>}
    </div>
    )
}